"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _natsConnection = _interopRequireDefault(require("@scoir/nats-connection"));

var _cookie = _interopRequireDefault(require("cookie"));

var _isArray = _interopRequireDefault(require("lodash/isArray"));

var _each = _interopRequireDefault(require("lodash/each"));

var _values = _interopRequireDefault(require("lodash/values"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var PING_CHANNEL = 'ui.monitor';
var PING_INTERVAL_MS = 1000 * 60 * 2;
var _default = {
  init: function init(userId) {
    var pingContext = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var cbId = -1;
    var nats = (0, _natsConnection.default)(_cookie.default.parse(document.cookie).bearer);
    var messageCallbacks = {};
    var prefix = "ui.".concat(userId, ".");

    var pingMonitor = function pingMonitor() {
      nats.publish(PING_CHANNEL, _objectSpread(_objectSpread({}, pingContext), {}, {
        UserId: userId
      }));
    };

    nats.subscribe('>', function (msg, reply, subject) {
      var topic = subject.replace(prefix, '');
      var topicCallBacks = messageCallbacks[topic];

      if (topicCallBacks) {
        (0, _each.default)((0, _values.default)(topicCallBacks), function (cb) {
          return cb(msg);
        });
      }
    });
    pingMonitor();
    var interval = setInterval(pingMonitor, PING_INTERVAL_MS);
    return {
      connect: function connect(topic, cb) {
        var nextId = cbId++;
        var natsTopic = topic.replace(/ /g, '+');
        var topicCallBacks = messageCallbacks[natsTopic];

        if (topicCallBacks) {
          topicCallBacks[nextId] = cb;
        } else {
          messageCallbacks[natsTopic] = (0, _defineProperty2.default)({}, nextId, cb);
        }

        return function () {
          return delete messageCallbacks[natsTopic][nextId];
        };
      },
      publish: function publish(topic, message) {
        nats.publish(topic, message);
      },
      disconnect: function disconnect(disconnectRequest) {
        if ((0, _isArray.default)(disconnectRequest)) {
          (0, _each.default)(disconnectRequest, function (topic) {
            delete messageCallbacks[topic];
          });
        } else {
          delete messageCallbacks[disconnectRequest];
        }
      },
      logout: function logout() {
        clearInterval(interval);
        nats.close();
      }
    };
  }
};
exports.default = _default;